import { css } from 'styled-components';
export var ie11Edge = function ie11Edge(rules) {
  return css(["@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){", ";}@supports (-ms-ime-align:auto){", ";}"], rules, rules);
};